module.exports = __webpack_public_path__ + "static/band-sam-fbfc557869f9dab74e0ae5aabccd97d8.jpg";